import { Box } from '@mui/material'
import React, { FC } from 'react'
import { connect } from 'react-redux'
import { HardwareType, UserType } from '../../api/appAPI'
import Item, { LinkType } from '../../classes/Item'
import { actions as itemActions } from '../../redux/itemReducer'
import { actions as appActions } from '../../redux/appReducer'
import { StateType } from '../../redux/store'
import ItemComponent, { CabinetItemComponent } from '../Item/ItemComponent'
import { appConfig } from '../../config'

interface IProps {
    sidebarHeight: number
    items: Array<Item>
    hardwaresList: Array<HardwareType>
    openItemsName: Array<string>
    cabinetAddonD: number
    cabinetAddonP: number
    user: UserType | undefined
    isDemo: boolean

    addHardwareToItem(itemName: string, hId: number): void
    deleteHardwareFromItem(itemName: string, hId: number): void
    addOpenItem(itemName: string): void
    removeOpenItem(itemName: string): void
    addLink(itemName: string, link: LinkType): void
    setItemAddon(itemName: string, d: number, p: number): void
    setHardwareCount(itemName: string, localId: number, count: number): void
    setParamCountHardwarePerCM(itemName: string, localId: number, perCM: number): void
    openHardwareDetails(hId: number): void
    setCabinetAddonD(value: number): void
    setCabinetAddonP(value: number): void
}


const PricingSidebar: FC<IProps> = props => {
    return (
        <Box p={2} style={{ overflowY: 'auto', height: props.sidebarHeight }}>
            <CabinetItemComponent
                isAdmin={((props.user && props.user.role === 'admin') || props.isDemo) || false}
                addonD={props.cabinetAddonD}
                addonP={props.cabinetAddonP}
                setAddonD={props.setCabinetAddonD}
                setAddonP={props.setCabinetAddonP}
                clearPrice={props.items.reduce((sum, current) => sum + parseFloat(current.getClearPrice()), 0) * (props.isDemo ? Math.PI : 1)}
                nonMarkupPrice={props.items.reduce((sum, current) => sum + parseFloat(current.getNonMarkupPrice()), 0) * (props.isDemo ? Math.PI : 1)}
                price={props.items.reduce((sum, current) => sum + parseFloat(current.getPrice()), 0) * (props.isDemo ? Math.PI : 1)}
                weight={props.items.reduce((sum, current) => sum + parseFloat(current.getWeight()), 0).toFixed(appConfig.fractionDigits)}
            />
            {props.items.map(item => item.props.type !== 'section' &&
                <ItemComponent
                    key={item.name}
                    isAdmin={(props.user && props.user.role === 'admin') || false}
                    isDemo={props.isDemo}
                    item={item}
                    hardwareList={props.hardwaresList}
                    open={props.openItemsName.includes(item.name)}
                    addHardwareToItem={props.addHardwareToItem}
                    deleteHardwareFromItem={props.deleteHardwareFromItem}
                    addOpenItem={props.addOpenItem}
                    removeOpenItem={props.removeOpenItem}
                    addLink={props.addLink}
                    setItemAddon={props.setItemAddon}
                    setHardwareCount={props.setHardwareCount}
                    setParamCountHardwarePerCM={props.setParamCountHardwarePerCM}
                    openHardwareDetails={props.openHardwareDetails}
                />
            )}
        </Box>
    )
}

const mapStateToProps = (state: StateType) => ({
    user: state.appReducer.user,
    isDemo: state.appReducer.isDemo,
    sidebarHeight: state.appReducer.sidebarHeight,
    items: state.itemReducer.items,
    hardwaresList: state.itemReducer.hardwaresList,
    openItemsName: state.itemReducer.openItemsName,
    cabinetAddonD: state.itemReducer.cabinetAddonD,
    cabinetAddonP: state.itemReducer.cabinetAddonP,
})

export default connect(mapStateToProps, {
    addHardwareToItem: itemActions.addHardwareToItem,
    deleteHardwareFromItem: itemActions.deleteHardwareFromItem,
    addOpenItem: itemActions.addOpenItem,
    removeOpenItem: itemActions.removeOpenItem,
    addLink: itemActions.addLink,
    setItemAddon: itemActions.setItemAddon,
    setHardwareCount: itemActions.setHardwareCount,
    setParamCountHardwarePerCM: itemActions.setParamCountHardwarePerCM,
    setCabinetAddonD: itemActions.setCabinetAddonD,
    setCabinetAddonP: itemActions.setCabinetAddonP,
    openHardwareDetails: appActions.openHardwareDetails,
})(PricingSidebar)